<template>
  <div v-show="isViewActiveLocal" class="text-left mt-2">
    <div class="w-full" v-show="!isFaqListHidden">
      <vx-card id="faqsCard" title="">
        <vs-table
          ref="faqsTable"
          stripe
          class="vs-con-loading__container"
          single
          @selected="handleSelectedFaq"
          pagination
          search
          :data="faqs"
        >
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          >
            <div>
              <div
                class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
                @click="addNewFaq"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary">Add New</span>
              </div>
            </div>
          </div>
          <template slot="thead">
            <vs-th sort-key="headingShort">Heading</vs-th>
            <vs-th sort-key="descriptionShort">Question</vs-th>
            <vs-th sort-key="answerShort">Answer</vs-th>
            <vs-th sort-key="module">Module</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="faq" :key="indextr" v-for="(faq, indextr) in data">
              <vs-td :data="data[indextr].heading">
                {{ faq.headingShort }}
              </vs-td>

              <vs-td :data="data[indextr].question">
                {{ faq.questionShort }}
              </vs-td>

              <vs-td :data="data[indextr].answer">
                {{ faq.answerShort }}
              </vs-td>
              <vs-td :data="data[indextr].module">
                {{
                  modulesList.filter(function (item) {
                    return item.value == faq.moduleId;
                  })[0].label
                }}
              </vs-td>
              <vs-td :data="data[indextr].modifiedOn">
                {{ faq.modifiedOn.replace("T", " ").split(".")[0] }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div>
      <vx-card
        id="faqInfoCard"
        ref="faqInfo"
        :title="mode"
        v-show="!isInfoHidden"
      >
        <vs-divider>Q&A Details</vs-divider>
        <div class="vx-row pb-1">
          <div class="vx-col w-full mb-2">
            <label>Heading</label>
            <vs-input
              autocomplete="off"
              onClick="this.select();"
              v-validate="'required'"
              name="Heading"
              class="w-full"
              v-model="formData.heading"
            />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Question</label>
            <vs-input
              autocomplete="off"
              onClick="this.select();"
              v-validate="'required'"
              name="Question"
              class="w-full"
              v-model="formData.description"
            />
          </div>
          <div class="vx-col w-full mb-2">
            <label>Answer</label>
            <vs-textarea
              autocomplete="off"
              onClick="this.select();"
              v-validate="'required'"
              name="Answer"
              v-model="formData.answer"
            />
          </div>
          <div class="vx-col sm:w-full w-full mb-2">
            <label>Module</label>
            <v-select
              ref="moduleDropdown"
              placeholder="Select a Module"
              :options="modulesList"
              v-validate="'required'"
              name="Module"
              class="w-full"
              v-model="moduleDropdown"
            ></v-select>
          </div>
        </div>
        <vs-divider>Tags</vs-divider>

        <div class="vx-row">
          <vs-chips
            id="tags"
            class="vx-col w-full"
            color="rgb(145, 32, 159)"
            placeholder="Add Tags"
            v-model="formData.tags"
          >
            <vs-chip
              class="glow-effect_primary"
              :key="chip"
              @click="removeTag(chip)"
              v-for="chip in formData.tags"
              closable
            >
              {{ chip }}
            </vs-chip>
          </vs-chips>
        </div>

        <div class="vx-row pb-3" v-if="formData.id">
          <div class="vx-col w-full">
            <vs-divider>Multimedia</vs-divider>
            <vs-collapse class="border">
              <vs-collapse-item id="subjectCollapse" ref="multimedia_collapse" class="vs-con-loading__container">
                <div slot="header">
                  Multimedia
                </div>
                <div style="overflow: auto;height:600px!important">
                  <v-select ref="mediaDropdown" placeholder="Search / Select Media item to Link" @search:blur="linkMedia" :options="notLinkedMedia" v-model="mediaDropdown"></v-select>
                  <vs-table  ref="mediaTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="linkedMedia">
                    <template slot="thead">
                      <vs-th></vs-th>
                      <vs-th>Media</vs-th>
                      <vs-th></vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :data="linkedMedia" :key="indextr" v-for="(_item, indextr) in data">
                        <vs-td style="text-align: -webkit-center;width:80px;text-align: -moz-center;">
                          <img v-if="_item.type == 1" src="@/assets/images/multi-media-video-icon.png" height=50px />
                          <img v-else-if="_item.type == 2" src="@/assets/images/multi-media-book-icon.png" height="50px" />
                          <img v-else-if="_item.type == 3" src="@/assets/images/multi-media-podcast-icon.png" height=50px />
                        </vs-td>
                        <vs-td :data="data[indextr].label">
                          {{_item.label}}
                        </vs-td>
                        <vs-td>
                          <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="areYouSure(_item.value, _item.type)"></vs-button>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>

        <vs-divider class="mb-6 pt-0"></vs-divider>
        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col flex">
            <vx-card
              class="mb-4 glow-effect_dark card__no-padding bg-color mr-3"
            >
              <vx-input-group>
                <template slot="prepend">
                  <div
                    class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg"
                  >
                    <span
                      ><feather-icon
                        class="pt-2"
                        icon="CheckIcon"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  class="w-full button__fully-opaque button-text__left-align glow-effect_success vs-con-loading__container"
                  color="success"
                  style="border-radius: 0 7px 7px 0"
                  ref="saveEditButton"
                  @click="saveEditFaq"
                >
                  Save
                </vs-button>
              </vx-input-group>
            </vx-card>
            <vx-card
              v-show="formData.id"
              class="mb-4 glow-effect_dark card__no-padding bg-color mr-3"
            >
              <vx-input-group>
                <template slot="prepend">
                  <div
                    class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg"
                  >
                    <span
                      ><feather-icon
                        class="pt-2"
                        icon="Trash2Icon"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  class="w-full button__fully-opaque button-text__left-align glow-effect_danger vs-con-loading__container"
                  color="danger"
                  style="border-radius: 0 7px 7px 0"
                  ref="deleteButton"
                  @click="deleteFaq"
                >
                  Delete
                </vs-button>
              </vx-input-group>
            </vx-card>
            <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color">
              <vx-input-group>
                <template slot="prepend">
                  <div
                    class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg"
                  >
                    <span
                      ><feather-icon
                        class="pt-2"
                        icon="XIcon"
                        svg-classes="stroke-current"
                      ></feather-icon
                    ></span>
                  </div>
                </template>

                <vs-button
                  size="large"
                  class="w-full button__fully-opaque button-text__left-align glow-effect_warning"
                  color="warning"
                  style="border-radius: 0 7px 7px 0"
                  @click="cancelAdd"
                >
                  Cancel
                </vs-button>
              </vx-input-group>
            </vx-card>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
export default {
  props: {
    isViewActive: {
      required: false,
    },
    faqs: {
      required: false
    },
    modulesList: {
      required: false
    }
  },
  data() {
    return {
      isFaqListHidden: false,
      isInfoHidden: true,
      formData: {
        id: 0,
        heading: "",
        answer: "",
        description: "",
        moduleId: 0,
        isActive: false,
        tags: [],
      },
      moduleDropdown: 0,
      mode: "",
      mediaContent: [],
      mediaDropdown: 0,
      notLinkedMedia: [],
      linkedMedia: [],
      mediaToUnlink: {}
    };
  },
  components: {
    vSelect
  },
  watch: {
    isViewActive: function (val) {
      if(val){
        
      }
    }
  },
  computed: {
    isViewActiveLocal: {
      get() {
        return this.isViewActive;
      }
    },
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.heading = "";
      this.formData.description = "";
      this.formData.answer = "";
      this.formData.moduleId = 0;
      this.formData.tags = [];
      this.moduleDropdown = 0;
      this.mediaDropdown = 0;
      this.notLinkedMedia = [];
      this.linkedMedia = [];
      this.mode = "";
      this.errors.clear();
    },
    addNewFaq() {
      this.initValues();
      this.mode = "Add Q&A";
      this.isFaqListHidden = true;
      this.isInfoHidden = false;
      this.$emit("hideBackButton");
    },
    cancelAdd() {
      this.initValues();
      this.isInfoHidden = true;
      this.isFaqListHidden = false;
      this.$emit("showBackButton");
    },
    handleSelectedFaq(faq) {
      var self = this;
      self.$emit("hideBackButton");
      self.mode = "Edit Q&A";
      self.isFaqListHidden = true;
      self.isInfoHidden = false;
      self.formData.id = faq.id;
      self.formData.mentorId = faq.mentorId;
      self.formData.moduleId = faq.moduleId;
      self.formData.heading = faq.heading;
      self.formData.description = faq.question;
      self.formData.answer = faq.answer;
      self.formData.tags = faq.tags;

      setTimeout(function() {
        self.getMediaDropdownList();
      }, 100)

      self.moduleDropdown = self.modulesList.filter(function (item) {
        return item.value == faq.moduleId;
      })[0];
    },
    deleteFaq() {
      var self = this;
      self.showLoadingOnElement("deleteButton", 0.45, "material");
      var onSuccess = (response) => {
        self.isInfoHidden = true;
        self.isFaqListHidden = false;
        self.$emit("showBackButton");
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Q&A Deleted",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-trash-2",
        });
        self.$emit("getFaqs");
      };

      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxGet(
        self,
        "Faq/DeleteFaq/" + self.formData.id,
        onSuccess,
        onFinally
      );
    },
    saveEditFaq() {
      var self = this;
      self.formData.moduleId = self.moduleDropdown
        ? parseInt(self.moduleDropdown.value)
        : null;
      self.$validator.validateAll().then((result) => {
        if (result) {
          self.showLoadingOnElement("saveEditButton", 0.45, "material");
          var onSuccess = (response) => {
            self.isInfoHidden = true;
            self.isFaqListHidden = false;
            self.$emit("showBackButton");
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Q&A Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save",
            });
            self.$emit("getFaqs");
          };

          var onFinally = function () {
            self.$vs.loading.close(self.$refs.saveEditButton.$el);
          };

          self.$ajaxPost(
            self,
            "Faq/AddEditFaqs",
            self.formData,
            onSuccess,
            onFinally
          );
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info",
          });
        }
      });
    },
    removeTag(tagItem) {
      this.formData.tags.splice(this.formData.tags.indexOf(tagItem), 1);
    },
    getMediaDropdownList() {
      const self = this;
      self.showLoadingOnElement("multimedia_collapse", 0.75, "material")
      var onSuccess = function (response) {
        self.notLinkedMedia = response.data.filter(function (item) {
          return !item.linked;
        });
        self.linkedMedia = response.data.filter(function(item){
          return item.linked;
        });
      };
      var onFinally = function () {
        if (self.$refs.multimedia_collapse) {
          self.$vs.loading.close(self.$refs.multimedia_collapse.$el);
        }
      };       
      self.$ajaxGet(self, `Faq/GetMediaList?faqId=${self.formData.id}&moduleId=${self.formData.moduleId}`, onSuccess, onFinally);
    },
    linkMedia() {
      var self = this;
      if (self.mediaDropdown.value) {
        self.showLoadingOnElement("mediaTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title: 'Information',
            color: "success",
            text: `Media linked to Q&A item`,
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.mediaTable.$el);
          self.getMediaDropdownList();
          self.mediaDropdown = 0;
        };

        self.$ajaxGet(self, `Faq/LinkMedia?mediaItemId=${parseInt(self.mediaDropdown.value)}&faqId=${self.formData.id}&type=${self.mediaDropdown.type}` , onSuccess, onFinally);
      }
    },
    areYouSure(mediaItemId, type) {
      var self = this;

      self.mediaToUnlink = {
        mediaItemId: mediaItemId,
        type: type
      };

      self.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: `Are you sure you want to remove the selected multimedia?`,
        accept: self.unlinkMedia,
        acceptText: "Yes",
        cancelText: "No"
      })
    },
    unlinkMedia() {
      var self = this;
      self.showLoadingOnElement("mediaTable", 1, "corners");

      var onSuccess = response => {
        self.$vs.notify({
          title: 'Information',
          color: "success",
          text: `Media unlinked from Q&A item`,
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-x'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.mediaTable.$el);
        self.getMediaDropdownList();
      };

      self.$ajaxGet(self, `Faq/UnlinkMedia?mediaItemId=${parseInt(self.mediaToUnlink.mediaItemId)}&faqId=${self.formData.id}&type=${self.mediaToUnlink.type}` , onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
  },
};
</script>

<style lang="scss">
.theme-dark {
  .style-chooser-light {
    .vs__actions {
      mix-blend-mode: inherit !important;
    }

    .selected-tag {
      background: #b7b7b7;
    }

    .dropdown-menu {
      color: #3d3d3d !important;
    }
  }

  #filter-select input {
    color: #3d3d3d !important;
  }
}

#submit-button {
  &.vs-button {
    .vs-button--icon {
      font-size: 1.3rem !important;
    }
  }
}

.swiper-inner {
  overflow: hidden;
  // padding: 15px;
  widows: 100% !important;
}

.swiper-container {
  width: 100% !important;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
}
</style>
